export default "__VITE_ASSET__7e5b0c5e__"